import { ReactNode } from "react";
import { BuildHtml } from "~/components/BuildHtml";
import { Link, LinkProps } from "~/ui-library";

interface BylineSimpleAuthor {
  href: string;
  authorName: string;
}

export type AuthorBylineSimpleProps = {
  authors: BylineSimpleAuthor[];
  className?: string;
  linkAppearance?: LinkProps["appearance"];
};

export function AuthorBylineSimple({
  authors,
  className,
  linkAppearance,
}: AuthorBylineSimpleProps): JSX.Element | null {
  if (!authors.length) return null;
  if (authors.length === 1)
    return (
      <div className={className}>
        By&nbsp;
        <Link appearance={linkAppearance} href={authors[0].href}>
          <BuildHtml html={authors[0].authorName} />
        </Link>
      </div>
    );

  const authorsArray: ReactNode[] = [];

  authors.forEach((author, index) => {
    if (index === authors.length - 1) {
      authorsArray.push(
        <Link
          appearance={linkAppearance}
          href={author.href}
          key={author.authorName}
        >
          {author.authorName}
        </Link>
      );
    } else if (index === authors.length - 2) {
      authorsArray.push(
        <Link
          appearance={linkAppearance}
          href={author.href}
          key={author.authorName}
        >
          {author.authorName}
        </Link>,
        " & "
      );
    } else {
      authorsArray.push(
        <Link
          appearance={linkAppearance}
          href={author.href}
          key={author.authorName}
        >
          {author.authorName}
        </Link>,
        ", "
      );
    }
  });
  return (
    <div className={className}>
      <span>By&nbsp;</span>
      {authorsArray}
    </div>
  );
}
